<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM17 11C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H9.416L10.7071 14.2929L10.7903 14.3871C11.0953 14.7794 11.0676 15.3466 10.7071 15.7071C10.3166 16.0976 9.68342 16.0976 9.29289 15.7071L6.29289 12.7071L6.21969 12.6254L6.146 12.5207L6.09367 12.4232L6.04974 12.3121L6.02024 12.2007L6.00279 12.0752L6 12L6.00691 11.8819L6.03585 11.734L6.07123 11.6287L6.12467 11.5159L6.19633 11.4047L6.2515 11.3369L6.29289 11.2929L9.29289 8.29289L9.3871 8.2097C9.77939 7.90468 10.3466 7.93241 10.7071 8.29289L10.7903 8.3871L10.8596 8.4886C11.0884 8.87249 11.0375 9.37666 10.7071 9.70711L9.414 11H17Z"
    fill="currentColor"
  />
</svg>
